import { Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Notification } from 'models';
import isExternalUrl from 'utils/isExternalUrl';
import { StyledCarousel, StyledPaper, GridBox, StyledMarkdown } from './NotificationCentre.styles';

export interface NotificationCentreProps {
  items: Notification[];
  className?: string;
}

const NotificationCentre = ({ items, className }: NotificationCentreProps) => (
  <StyledCarousel className={className}>
    {items.map(
      ({
        id,
        title,
        description,
        image: Image,
        imageProps,
        path,
        onClick,
        callToAction = 'Take me there',
      }) => (
        <StyledPaper key={id} aria-label="Perk notification">
          <GridBox>
            <Typography variant="h3">{title}</Typography>
            <Image {...imageProps} />
            <StyledMarkdown>{description}</StyledMarkdown>
            <Button
              color="primary"
              fullWidth
              variant="contained"
              component={Link}
              disableRipple
              onClick={onClick}
              to={isExternalUrl(path) ? { pathname: path } : path}
              target={isExternalUrl(path) ? '_blank' : '_self'}
            >
              {callToAction}
            </Button>
          </GridBox>
        </StyledPaper>
      )
    )}
  </StyledCarousel>
);

export default NotificationCentre;
